export function normalizeFeatureAccess(list) {
  return (list || []).reduce((result, item) => {
    if (item && item.featureKey) {
      result[item.featureKey] = item;
    }
    return result;
  }, {});
}

export function canShowFeature(featureAccess, featureKey) {
  if (!featureKey) return true;

  const rule = featureAccess && featureAccess[featureKey];
  return !rule || rule.visible !== false;
}
